import React from "react";
import _ from "lodash";
import {Grid} from "@material-ui/core";

import DashboardTable from "../../../../../../../../components/DashboardTable/DashboardTable";
import {favoriteListDetailsTableStructure} from "../../../../../../../Modelportfolios/components/InstrumentsList/table-data";
import AssetsSelectionPage
  from "../../../../../../../RiskProfiling/components/StepContent/components/step/ProductSelectionStepsV2/components/AssetsSelection/components/AssetsSelectionPage";
import EmptyTableMessage from "../../../../../../../RiskProfiling/components/EmptyTableMessage";


const MainStep = ({
  classes,
  disabledInstruments,
  assetsSearch,
  handleSearchActivate,
  handleAddAssetFromSearch,
  handleToggleAsset,
  instrumentsSources,
  onFiltersClick,
  isCustomerApp,
  assets,
  selectedAssets,
  instrumentsHandler,
  onSelectAll,
  children
}) => {
  const handleAllSelect = React.useCallback(() => {
    const allSelected = selectedAssets.length === assets.length;
    onSelectAll(!allSelected);
  }, [selectedAssets.length, assets.length, onSelectAll]);

  return (
    <AssetsSelectionPage
      instrumentsHandler={instrumentsHandler}
      assetsSearch={assetsSearch}
      handleSearchActivate={handleSearchActivate}
      assets={disabledInstruments}
      instrumentsSources={instrumentsSources}
      handleAddAssetClick={handleAddAssetFromSearch}
      handleFiltersExtendedButtonClick={onFiltersClick}
      isCustomerApp={isCustomerApp}
    >
      <Grid item xs={12}>
        <div className={classes.header}>Produktauswahl</div>
        <DashboardTable
          tableLayout="auto"
          structure={favoriteListDetailsTableStructure}
          dataSource={assets}
          expanded={true}
          withFooter={false}
          emptyDataMessage={<EmptyTableMessage />}
          options={{
            totalInstrumentsCount: assets.length,
            onInstrumentSelect: handleToggleAsset,
            onAllSelect: assets.length ? handleAllSelect : undefined,
            selected: selectedAssets,
          }}
        />
        {children}
      </Grid>
    </AssetsSelectionPage>
  );
}

export default React.memo(MainStep);
